import { HEADER_HEIGHT } from 'src/modules/renderings/components/Layout/Header';
import { isMobileApp } from 'src/shared/helpers/environment';

const useHeaderHeight = (): number => (isMobileApp() ? 0 : HEADER_HEIGHT);

export { useHeaderHeight };
